<div
  class=""
  ng-init="resizeSubChild()"
  (window:resize)="onResize()"
  (window:onload)="onResize()"
  [style.height.px]="divHeight"
>
  <div class="">
    <form [formGroup]="EnergyMeterForm" (ngSubmit)="OnSave()">
      <div class="position-reletivediv popup-inner-space border-bottom-grey">
        <div class="betweenheader color_black">Site and EnergyMeter list</div>

        <div class="text-right flow-right">
          <img
            src="assets/images/close_icon.svg"
            alt="..."
            class="img-fluid closeicon2 cursor-pointer"
            (click)="Close()"
          />
        </div>
      </div>
      <div class="errmsg" *ngIf="errorMsg" style="margin-left: 1%">
        {{ errorMsg }}
      </div>
      <div class="sucessmsg" *ngIf="successMsg" style="margin-left: 1%">
        {{ successMsg }}
      </div>
      <div
        class="company-table margin-top-20 tabel-scrolling"
        formArrayName="SiteArray"
        [style.height.px]="tableHeight"
        style="margin: 10px 15px"
      >
        <table
          class="table"
          *ngFor="
            let lstsite of EnergyMeterForm['controls'].SiteArray['controls'];
            let ix = index
          "
          formGroupName="{{ ix }}"
          id="tableFlowmeterlisttbl"
        >
          <thead class="companytable">
            <tr>
              <!-- <th class="width10"><input class="inputcheckbox" type="checkbox"></th> -->
              <th class="" *ngIf="ix == 0"></th>
              <th *ngIf="ix == 0" class="color_black">Site Name</th>
              <th class="" *ngIf="ix == 0"></th>
              <th class="" *ngIf="ix == 0"></th>
            </tr>
          </thead>
          <tbody
            class="companytable border-bottom"
            infinite-scroll
            id="tbodyFlowmeterlisttbl"
          >
            <!-- <div > -->
            <tr id="{{ 'trFlowmeterlisttbl' + ix }}">
              <td class="plusicon pl-3" id="{{ 'tdFlowmeterlisttbl' + ix }}">
                <img
                  class="cursor-pointer comman-icon"
                  *ngIf="!lstsite.value.IsShowChild"
                  src="/assets/images/add-icon.svg"
                  (click)="ShowChild('Y', ix)"
                  id="{{ 'imgFlowmeterlistaddicon' + ix }}"
                />
                <img
                  class="cursor-pointer comman-icon"
                  *ngIf="lstsite.value.IsShowChild"
                  src="/assets/images/delete-icon.svg"
                  (click)="ShowChild('N', ix)"
                  id="{{ 'imgFlowmeterlistdeleteicon' + ix }}"
                />
              </td>
              <!-- <td class="width10"></td> -->
              <!-- <td class="width7 text-center"><input class="inputcheckbox" type="checkbox" formControlName="IsAssigned"
                                    [checked]="lstsite.value.IsAssigned" (change)="SelectAll(lstsite.value.IsAssigned,ix)"></td> -->
              <td
                id="{{ 'tdFlowmeterlistCompSiteName' + ix }}"
                class="bottom-border"
              >
                {{ lstsite.value.CompSiteName }}
              </td>
              <td
                id="{{ 'tdFlowmeterlistCompsitenameblnk' + ix }}"
                colspan="2"
                class="bottom-border"
              ></td>
            </tr>
            <tr
              *ngIf="lstsite.value.IsShowChild"
              id="{{ 'trFlowmeterlistIsShowChild' + ix }}"
            >
              <td></td>

              <td
                colspan="3"
                class="bottom-border padding-left-5"
                formArrayName="PanelArray"
                id="{{ 'trFlowmeterlistlstpanel' + ix }}"
              >
                <table
                  id="{{ 'tableFlowmeterlistlstsite' + ix }}"
                  class="table company-table margin-top-0"
                  *ngFor="
                    let lstpanel of lstsite['controls'].PanelArray['controls'];
                    let iy = index
                  "
                  formGroupName="{{ iy }}"
                >
                  <thead
                    class="companytable"
                    id="{{ 'theadFlowmeterlistlstsite' + ix }}"
                  >
                    <tr id="{{ 'trFlowmeterlistlstsite' + ix }}">
                      <th
                        class="width5"
                        id="{{ 'thFlowmeterlistlstsite' + ix }}"
                      ></th>
                      <th class="" id="{{ 'thFlowmeterlistpanelname' + ix }}">
                        Location Name
                      </th>
                    </tr>
                  </thead>
                  <tbody
                    class="companytable"
                    id="{{ 'tbodyFlowmeterlistIsAssigned' + ix }}"
                  >
                    <tr id="{{ 'trFlowmeterlistIsAssigned' + ix }}">
                      <td
                        id="{{ 'tdFlowmeterlistchkIsAssigned' + ix }}"
                        class="width5 text-center cursor-pointer"
                      >
                        <input
                          class="inputcheckbox"
                          type="checkbox"
                          formControlName="IsAssigned"
                          (change)="
                            SelectPanel(lstpanel.value.IsAssigned, ix, iy)
                          "
                        />
                      </td>
                      <td class="" id="{{ 'tdFlowmeterlistIsAssigned' + ix }}">
                        {{ lstpanel.value.PanelName }}
                      </td>
                    </tr>
                    <tr
                      *ngIf="lstsite.value.IsShowChild"
                      id="{{ 'trFlowmeterlistDeviceArray' + ix }}"
                    >
                      <td></td>
                      <td
                        id="{{ 'tdFlowmeterlistIsAssigned' + ix }}"
                        colspan="1"
                        class="bottom-border"
                        formArrayName="DeviceArray"
                      >
                        <table
                          class="table company-table margin-top-0"
                          *ngFor="
                            let lstdevice of lstpanel['controls'].DeviceArray[
                              'controls'
                            ];
                            let iz = index
                          "
                          formGroupName="{{ iz }}"
                          id="{{ 'tableFlowmeterlistDeviceArray' + ix }}"
                        >
                          <thead
                            class="companytable"
                            id="{{ 'theadFlowmeterlistDeviceName' + ix }}"
                          >
                            <tr id="{{ 'trFlowmeterlistDeviceName' + ix }}">
                              <th
                                class="width5"
                                id="{{ 'thFlowmeterlistDeviceName' + ix }}"
                              ></th>
                              <th
                                class=""
                                id="{{ 'thFlowmeterlistlblDeviceName' + ix }}"
                              >
                                Device Name
                              </th>
                            </tr>
                          </thead>
                          <tbody
                            class="companytable"
                            id="{{ 'tbodyFlowmeterlistlstdevice' + ix }}"
                          >
                            <tr id="{{ 'trFlowmeterlistlstdevice' + ix }}">
                              <td
                                id="{{ 'tdFlowmeterlistlstdevice' + ix }}"
                                class="width5 text-center cursor-pointer"
                              >
                                <input
                                  class="inputcheckbox"
                                  type="checkbox"
                                  formControlName="IsAssigned"
                                  (change)="
                                    SelectDevice(
                                      lstpanel,
                                      lstdevice.value.IsAssigned,
                                      ix,
                                      iy,
                                      iz
                                    )
                                  "
                                />
                              </td>
                              <td
                                class=""
                                id="{{ 'tdFlowmeterlistlstdevice' + ix }}"
                              >
                                {{ lstdevice.value.DeviceName }}
                              </td>
                            </tr>
                            <tr
                              *ngIf="lstsite.value.IsShowChild"
                              id="{{ 'trFlowmeterlistMeterName' + ix }}"
                            >
                              <td></td>
                              <td id="{{ 'tdFlowmeterlistMeterName' + ix }}">
                                <table
                                  class="table company-table margin-top-0"
                                  id="{{ 'tableFlowmeterlistMeterName' + ix }}"
                                >
                                  <thead
                                    class="companytable"
                                    id="{{
                                      'theadFlowmeterlistMeterName' + ix
                                    }}"
                                  >
                                    <tr
                                      id="{{ 'trFlowmeterlistMeterName' + ix }}"
                                    >
                                      <th
                                        id="{{
                                          'thFlowmeterlistMeterName' + ix
                                        }}"
                                        class="width5"
                                      ></th>
                                      <th
                                        id="{{
                                          'thFlowmeterlistlblMeterName' + ix
                                        }}"
                                        class=""
                                      >
                                        Meter Name
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody
                                    class="companytable"
                                    formArrayName="EnergyMeterArray"
                                    id="{{
                                      'tbodyFlowmeterlistSelectEnergy' + ix
                                    }}"
                                  >
                                    <tr
                                      *ngFor="
                                        let lstenergy of lstdevice['controls']
                                          .EnergyMeterArray['controls'];
                                        let ie = index
                                      "
                                      formGroupName="{{ ie }}"
                                      id="{{
                                        'trFlowmeterlistSelectEnergy' + ix
                                      }}"
                                    >
                                      <td
                                        class="width5 text-center cursor-pointer"
                                        id="{{
                                          'tdFlowmeterlistchkSelectEnergy' + ix
                                        }}"
                                      >
                                        <input
                                          class="inputcheckbox"
                                          type="checkbox"
                                          formControlName="IsAssigned"
                                          (change)="
                                            SelectEnergy(lstdevice, ix, iy, iz)
                                          "
                                          id="{{
                                            'txtFlowmeterlistchkSelectEnergy' +
                                              ix
                                          }}"
                                        />
                                      </td>
                                      <td
                                        class=""
                                        id="{{
                                          'tdFlowmeterlistlstenergy' + ix
                                        }}"
                                      >
                                        {{ lstenergy.value.EnergymeterID }}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <!-- </div> -->
          </tbody>
        </table>
      </div>
      <div class="company-btn2_1">
        <button type="submit" class="btncommon" id="btnflowmeterlistsave">
          Save
        </button>
        <button
          class="btncommon-grey btn-border-add-company margin-left-10"
          (click)="OnCancel()"
          id="btnflowmeterlistcancel"
        >
          Cancel
        </button>
      </div>
    </form>
  </div>
</div>
